/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Jobs

1 = Jobs

2 = Subs

3 = Owner Invoices

4 = InvoiceARAccountID

5 = InvoiceItemID

6 = Bills

7 = BillAPAccountID

8 = CostCodeID

9 = CostCodeExpenseAccountID

10 = CostCodeIncomeAccountID

11 = VendorCreditID

12 = CustomerInvoiceID

13 = Online Payments

14 = Internal Users

15 = MerchantFeeAccount

16 = BankAccountID

17 = MerchantFee

18 = Online Payment Methods

20 = POMerchantFeeAccount

21 = Income Account

22 = Cost Codes

23 = Company Name

24 = Preferences

25 = HostID

26 = Estimates

27 = Sales Tax Codes

28 = Item Sales Tax

29 = DeletedQBTransactions

30 = DeletedQBLists

31 = JournalEntry

32 = Time Cards

33 = TransactionDeleteID

34 = Default Payroll Item

35 = Misc Query Information

36 = MassEmployeeModID

37 = BillPaymentID

38 = Bill Payment Checks

39 = Bill Payment Credit Cards

40 = OtherCosts

41 = Other Accounting Costs (Credit Card Charge)

42 = Other Accounting Costs (Check)

43 = Credit memos

44 = TaxGroups

45 = InvoiceLineItems

46 = TaxAgency

47 = CreditMemoLineItems

48 = Attachment

49 = BankDeposit

50 = Projects

51 = Cost Types

-1 = None


 */
export type IDTypes = (typeof IDTypes)[keyof typeof IDTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const IDTypes = {
  CustomerID: 0,
  JobID: 1,
  VendorID: 2,
  InvoiceID: 3,
  InvoiceARAccountID: 4,
  InvoiceItemID: 5,
  BillID: 6,
  BillAPAccountID: 7,
  CostCodeID: 8,
  CostCodeExpenseAccountID: 9,
  CostCodeIncomeAccountID: 10,
  VendorCreditID: 11,
  CustomerInvoiceID: 12,
  Payment: 13,
  EmployeeID: 14,
  MerchantFeeAccount: 15,
  BankAccountID: 16,
  MerchantFee: 17,
  PaymentMethodBankAccount: 18,
  POMerchantFeeAccount: 20,
  AccountID: 21,
  ItemID: 22,
  CompanyID: 23,
  PreferenceID: 24,
  HostID: 25,
  EstimateID: 26,
  SalesTaxCodeID: 27,
  ItemSalesTaxID: 28,
  DeletedQBTransactions: 29,
  DeletedQBLists: 30,
  JournalEntry: 31,
  TimeActivityID: 32,
  TransactionDeleteID: 33,
  PayrollItemID: 34,
  MiscQueryInformation: 35,
  MassEmployeeModID: 36,
  BillPaymentID: 37,
  BillPaymentCheckID: 38,
  BillPaymentCreditCardID: 39,
  OtherCosts: 40,
  CreditCardCharge: 41,
  Check: 42,
  CreditMemo: 43,
  TaxGroups: 44,
  InvoiceLineItems: 45,
  TaxAgency: 46,
  CreditMemoLineItems: 47,
  Attachment: 48,
  BankDeposit: 49,
  Project: 50,
  CostTypeID: 51,
  None: -1,
} as const;
